/**
 * Utility functions for role formatting and display
 */

export const getRoleDisplay = (role: string): string => {
  const roleMap: { [key: string]: string } = {
    'VET_STAFF': 'Vet Staff',
    'PRACTICE_ADMIN': 'Practice Admin',
    'SYSTEM_ADMIN': 'Admin',
    'PET_OWNER': 'Pet Owner',
    'PENDING_INVITE': 'Pending Invite',
    'ADMIN': 'Admin',
  };
  return roleMap[role] || role;
};

